<template>
  <transition name="fade-transition">
    <v-card>
      <v-card-title style="padding:0.3em 1em 0">
        <h3>{{ furnizor.nume_furnizor }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="show = !show">
          <v-icon>{{ !show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-title style="padding: 0 1em 0.3em">
        <div>
          <h4>{{ tipFui }}</h4>
          <h4>Valoare factura(lei): {{ valoare_factura_furnizor_fc | price }}</h4>
          <h4 v-if="furnizor.ultima_instanta !== 1">
            <strong>Diferenta FUI optional - FUI obligatoriu</strong>:
            <v-icon v-if="diferentaProcentualaFui > 0" color="red">arrow_upward</v-icon>
            <v-icon v-else-if="diferentaProcentualaFui < 0" color="green">arrow_downward</v-icon>
            {{ diferentaProcentualaFui | abs | price }}%
          </h4>
        </div>
      </v-card-title>
      <v-slide-y-transition>
        <v-card-text v-show="show">
          <ul v-if="isFuiObligator && isHomeUser">
            <li><strong>Perioada de aplicare</strong>: {{ perioadaAplicare | interval }}</li>
            <li><strong>Pret reglementat (lei/{{ um.um }})</strong>: {{ pretEnergie | price(5) }}</li>
            <li><strong>Contravaloare certificate verzi (lei/{{ um.um }})</strong>: <span>{{ contravaloareCV | price(5) }}</span></li>
            <li><strong>Taxa cogenerare inalta eficienta (lei/{{ um.um }})</strong>: <span>{{ taxaCogenerare | price(5) }}</span></li>
            <li><strong>Acciza (lei/{{ um.um }})</strong>: <span>{{ _acciza | price(5) }}</span></li>
            <li><strong>TVA (%)</strong>: <span>{{ tarif.tva }}</span></li>
          </ul>
          <ul v-else>
            <li><strong>Perioada de aplicare</strong>: {{ perioadaAplicare | interval }}</li>
            <li><strong>Pret energie (lei/{{ um.um }})</strong>: {{ pretEnergie | price(5) }}</li>
            <li><strong>Tarif transport TL (lei/{{ um.um }})</strong>: {{ tarifTransportTL | price(5) }}</li>
            <li><strong>Tarif serviciu sistem (lei/{{ um.um }})</strong>: {{ tarifServiciuSistem | price(5) }}</li>
            <li><strong>Tarif serviciu distributie (lei/{{ um.um }})</strong>: <span>{{ tarifDistributie | price(5) }}</span></li>
            <li><strong>Contravaloare certificate verzi (lei/{{ um.um }})</strong>: <span>{{ contravaloareCV | price(5) }}</span></li>
            <li><strong>Taxa cogenerare inalta eficienta (lei/{{ um.um }})</strong>: <span>{{ taxaCogenerare | price(5) }}</span></li>
            <li><strong>Acciza (lei/{{ um.um }})</strong>: <span>{{ _acciza | price(5) }}</span></li>
            <li><strong>TVA (%)</strong>: <span>{{ tarif.tva }}</span></li>
          </ul>
        </v-card-text>
      </v-slide-y-transition>
    </v-card>
  </transition>
</template>
<script>
  export default {
    props: {
      furnizor: Object,
      zona: Object,
      tarif: Object,
      um: Object,
      fuiObligator: Number,
      acciza: Number,
      valoare_factura_furnizor_fc: Number
    },
    data() {
      return {
        show: false
      }
    },
    computed: {
      isFuiObligator() {
        return this.furnizor.ultima_instanta === 1;
      },
      isHomeUser() {
        return this.furnizor.tip_client === 'Casnic'
      },
      diferentaProcentualaFui() {
        return (this.valoare_factura_furnizor_fc - this.fuiObligator) / this.valoare_factura_furnizor_fc * 100;
      },
      perioadaAplicare() {
        return [
          this.furnizor.perioada_aplicare_min,
          this.furnizor.perioada_aplicare_max
        ];
      },
      tipFui() {
        return 'Oferta FUI ' + (this.furnizor.ultima_instanta === 2 ? 'optional' : 'obligat')
      },
      pretEnergie() {
        return this.divPrice(this.furnizor.pret_energie);
      },
      contravaloareCV() {
        return this.divPrice(this.furnizor.ccv);
      },
      tarifServiciuSistem() {
        return this.divPrice(this.tarif.tarif_serviciu_sistem);
      },
      tarifTransportTL() {
        return this.divPrice(this.tarif.tarif_transport_tl);
      },
      tarifDistributie() {
        return this.divPrice(this.zona.tarif_distributie);
      },
      taxaCogenerare() {
        return this.divPrice(this.tarif.taxa_cogenerare_inalta_eficienta);
      },
      _acciza() {
        return this.divPrice(this.acciza);
      },
    },
    methods: {
      divPrice(p) {
        return p === undefined ? p : p / this.um.div
      }
    },
    filters: {
      abs: v => Math.abs(v)
    }
  };
</script>
